import { AdaptiveButton } from '@pisano/feedback-core/app/components/AdaptiveElements';
import { archiveModal } from '../Chat/actions';
import { CHAT, THANK } from '@pisano/feedback-core/app/containers/FlowState/stateTypes';
import { closeWidget, hidePreviousFeedbacks, showPreviousFeedbacks } from '../Widget/actions';
import { configureTranslate } from '../../../react-translator';
import { connect } from 'react-redux';
import { previousState } from '@pisano/feedback-core/app/containers/Flow/actions';
import CaretRight from '@pisano/feedback-core/app/images/caret-right.svg';
import Close from '@pisano/feedback-core/app/images/close.svg';
import Hamburger from './images/hamburger.svg';
import PropTypes from 'prop-types';
import React from 'react';
import translations from '../../translations.json';
import withTranslation from '../../../feedback-core/app/hocs/withTranslation';

// TODO: This should not be here. But we are rushing for WCAG 2.2 compliance.
configureTranslate({ translations });

const renderPreviousFeedbacksToggle = (onClick, t) => (
  <AdaptiveButton className="widget-content-container__header__button left" onClick={onClick} aria-label={t('menu')}>
    <Hamburger />
  </AdaptiveButton>
);

const renderCloseButton = (onClick, t) => (
  <AdaptiveButton
    className="widget-content-container__header__button widget-close-button"
    onClick={onClick}
    aria-label={t('close')}
  >
    <CaretRight style={{ transform: 'rotate(90deg)' }} />
  </AdaptiveButton>
);

const renderArchiveButton = (onClick, t) => (
  <AdaptiveButton
    className="widget-content-container__header__button widget-archive-button"
    onClick={onClick}
    aria-label={t('archive')}
  >
    <Close />
  </AdaptiveButton>
);

const renderBackButton = (onClick, t) => (
  <AdaptiveButton className="widget-content-container__header__button left" onClick={onClick} aria-label={t('back')}>
    <CaretRight style={{ transform: 'rotate(180deg)' }} />
  </AdaptiveButton>
);

export function WidgetFrameHeader({
  backgroundColor,
  nodeLogoUrl,
  closeWidget,
  fontColor,
  isSelectingPreviousFeedback,
  showPreviousFeedbacks,
  hidePreviousFeedbacks,
  shouldRenderBackButton = false,
  shouldRenderPreviousFeedbacksToggle = false,
  previousState,
  archiveModal,
  chat,
  t,
}) {
  const togglePreviousFeedbacks = isSelectingPreviousFeedback ? hidePreviousFeedbacks : showPreviousFeedbacks;
  // Give priority to back button over previous feedbacks toggle.
  const backbButtonOnClick = isSelectingPreviousFeedback ? togglePreviousFeedbacks : previousState;
  const leftButton =
    (shouldRenderBackButton && renderBackButton(backbButtonOnClick, t)) ||
    (shouldRenderPreviousFeedbacksToggle && renderPreviousFeedbacksToggle(togglePreviousFeedbacks, t));
  return (
    <div className="widget-content-container__header" style={{ backgroundColor, color: fontColor }}>
      {leftButton}
      {nodeLogoUrl && <img src={nodeLogoUrl} alt="" className="logo" />}
      <div className="widget-content-container__header__button-group">
        {chat && chat.status === 'open' && renderArchiveButton(archiveModal, t)}
        {renderCloseButton(closeWidget, t)}
      </div>
    </div>
  );
}

WidgetFrameHeader.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  fontColor: PropTypes.string.isRequired,
  nodeLogoUrl: PropTypes.string,
  chat: PropTypes.object,
  closeWidget: PropTypes.func.isRequired,
  isSelectingPreviousFeedback: PropTypes.bool.isRequired,
  showPreviousFeedbacks: PropTypes.func.isRequired,
  hidePreviousFeedbacks: PropTypes.func.isRequired,
  previousState: PropTypes.func.isRequired,
  shouldRenderBackButton: PropTypes.bool,
  shouldRenderPreviousFeedbacksToggle: PropTypes.bool,
  archiveModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    backgroundColor: state.widget.primaryColor,
    fontColor: state.widget.fontColor,
    nodeLogoUrl: state.widget.nodeLogoUrl,
    isSelectingPreviousFeedback: state.widget.isSelectingPreviousFeedback,
    chat: state.chat,
    shouldRenderBackButton: !!(
      (state.flow &&
        state.flow.currentState.previousState &&
        state.flow.currentState.style !== THANK &&
        state.flow.currentState.style !== CHAT) ||
      state.widget.isSelectingPreviousFeedback
    ),
    shouldRenderPreviousFeedbacksToggle: false, // state.widget.previousFeedbacks.length > 0,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    closeWidget: () => dispatch(closeWidget()),
    showPreviousFeedbacks: () => dispatch(showPreviousFeedbacks()),
    hidePreviousFeedbacks: () => dispatch(hidePreviousFeedbacks()),
    previousState: () => dispatch(previousState()),
    archiveModal: () => dispatch(archiveModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(WidgetFrameHeader));
